import { render, staticRenderFns } from "./BaseCopyButton.vue?vue&type=template&id=7db2c9d4&"
import script from "./BaseCopyButton.vue?vue&type=script&lang=js&"
export * from "./BaseCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports